var map = {
	"./da.json": 918,
	"./de.json": 919,
	"./en.json": 920,
	"./es.json": 921,
	"./fr.json": 922,
	"./ko.json": 923,
	"./pl.json": 924,
	"./pt.json": 925,
	"./ru.json": 926,
	"./sv.json": 927,
	"./uk.json": 928,
	"./zh_CN.json": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 917;